import React, {useState, useEffect, useRef} from 'react';
import {findEnabledCustomersByQueryString} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";

const PdvSaleManagerCustomer = () => {
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const sale = JSON.parse(localStorage.getItem('pdvSale') || '{}');

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    async function makeQuery(query) {
        try {
            setLoading(true);
            const data = await findEnabledCustomersByQueryString(query);
            const sorted = (data || []).sort((a, b) =>
                removeSpecialChars(a.name).localeCompare(removeSpecialChars(b.name)));
            setCustomers(sorted);
            setFilteredCustomers(sorted);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) inputQueryString.current.focus();
        makeQuery('');
    }, []);

    const handleInputChange = (e) => {
        const string = removeSpecialChars(e.target.value).toUpperCase();
        const filtered = customers.filter(f => removeSpecialChars(f.name).toUpperCase().includes(string))
            .sort((a, b) => removeSpecialChars(a.name).localeCompare(removeSpecialChars(b.name)));
        setFilteredCustomers(filtered);
        setQueryString(string);
    };

    return (
        <>
            <div className="header-label">Comanda</div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                 className="input-container">
                <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                       onChange={handleInputChange} onFocus={(e) => e.target.select()} inputMode="numeric"/>
                <button id="clearButton" onClick={() => { setQueryString(''); inputQueryString.current.focus(); }}>X</button>
            </div>
            <table style={{width: '100%'}}>
                <colgroup>
                    <col style={{width: '300px'}}/>
                    <col style={{width: '50px'}}/>
                </colgroup>
                <thead><tr><th>Nome</th><th/></tr></thead>
                <tbody>
                {filteredCustomers.map((customer, index) => (
                    <tr key={index}>
                        <td><div>{customer.name}</div></td>
                        <td>
                            <button onClick={() => {
                                const newSale = {table: sale.table, customer: customer};
                                localStorage.setItem('pdvSale', JSON.stringify(newSale));
                                navigate('/pdv/items');
                            }}>Selecionar</button>
                        </td>
                    </tr>
                ))}
                </tbody>
                {customers.length === 0 && <tfoot><tr><td colSpan={2}>Nenhum item encontrado</td></tr></tfoot>}
            </table>
        </>
    );
};

export default PdvSaleManagerCustomer;
